import React from 'react'
import { AiResult } from '../../../../../../../models/AiResult'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { HeaderResultCRMButton } from './HeaderResultCRMButton/HeaderResultCRMButton'
import { IntegrationServiceId } from '../../../../../../../common/integrations'

interface ResultCardHeaderCRMButtonsProps {
  aiFeature: AiFeature
  aiResult: AiResult
}

export const ResultCardHeaderCRMButtons: React.FC<ResultCardHeaderCRMButtonsProps> = ({ aiFeature, aiResult }) => {
  return (
    <>
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.WEALTHBOX} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.SALESFORCE} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.REDTAIL} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.PRACTIFI} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.HUBSPOT} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.XLR8} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.ZOHO} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.DYNAMICS} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.SMARTOFFICE} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.ELEMENTS} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.BLACK_DIAMOND} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.ENGAGE} />
      <HeaderResultCRMButton aiFeature={aiFeature} aiResult={aiResult} serviceId={IntegrationServiceId.ADVISOR_ENGINE} />
    </>
  )
}
